// extracted by mini-css-extract-plugin
export var arrow = "Customers-module--arrow--9d5d3";
export var arrowIcon = "Customers-module--arrowIcon--38342";
export var item = "Customers-module--item--f412e";
export var prevArrow = "Customers-module--prevArrow--ea2a2";